import moment from "moment";
import { TableCell, TableRow, Typography } from "@mui/material";
import PropTypes from "prop-types";

import TableWrapper from "components/TableWrapper";
import Loader from "components/Loader";
import StatusChip from "components/StatusChip";
import { EDD_CHANGE_STATUS, RECENT_CHANGES_COLUMNS } from "constants/eddConfig";

const STATUS_CHIP_TYPE = {
  [EDD_CHANGE_STATUS.APPLIED]: "SUCCESS",
  [EDD_CHANGE_STATUS.PENDING]: "WARNING",
  [EDD_CHANGE_STATUS.FAILED]: "ERROR",
  UPLOADED: "INFO",
  NOT_STARTED: "INFO",
  COMPLETED: "SUCCESS",
  SUCCESS: "SUCCESS",
  PARTIAL: "WARNING",
  IN_PROGRESS: "WARNING",
  PROCESSING: "WARNING",
  COMPLETED_WITH_ERRORS: "WARNING",
  ROW_DATA_FAILURE: "ERROR",
  CANCELLED: "ERROR",
  FAILURE: "ERROR",
};

const RecentChanges = ({
  rows,
  isLoading,
  columns = RECENT_CHANGES_COLUMNS,
}) => {
  const renderCell = (field, row) => {
    const value = row[field];
    if (field === "changed_at") {
      return value ? moment(value).format("DD MMM YYYY, hh:mm A") : "-";
    }
    if (field === "status") {
      const status = String(value || "").toUpperCase();
      return (
        <StatusChip
          label={status || "-"}
          type={STATUS_CHIP_TYPE[status] || "INFO"}
        />
      );
    }
    return value ?? "-";
  };

  const tableHeader = columns.map((col) => (
    <TableCell
      key={col.field}
      sx={{ whiteSpace: "nowrap", minWidth: col.minWidth }}
    >
      {col.headerName}
    </TableCell>
  ));

  const renderMessageRow = (key, content) => [
    <TableRow key={key}>
      <TableCell colSpan={columns.length} align="center" sx={{ py: 4 }}>
        {content}
      </TableCell>
    </TableRow>,
  ];

  const tableBody = isLoading
    ? renderMessageRow("loading", <Loader size={28} sx={{ marginTop: 0 }} />)
    : !rows.length
    ? renderMessageRow(
        "empty",
        <Typography color="textSecondary">No changes found</Typography>,
      )
    : rows.map((row, idx) => (
        <TableRow key={row.id ?? idx} hover>
          {columns.map((col) => (
            <TableCell key={col.field} sx={{ fontSize: "0.85rem", py: 1 }}>
              {renderCell(col.field, row)}
            </TableCell>
          ))}
        </TableRow>
      ));

  return <TableWrapper tableHeader={tableHeader} tableBody={tableBody} />;
};

RecentChanges.propTypes = {
  rows: PropTypes.arrayOf(PropTypes.object).isRequired,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default RecentChanges;
